import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { CardKindViewType } from '@web/widgets/product-card/type';
import { type PreviewModalSettingsFormGroup, type PreviewModalSettingsFormType } from '@web/widgets/product-card/type';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import { TranslateModule } from '@ngx-translate/core';
import { TypographySettingsComponent } from '../common-settings/typography-settings/typography-settings.component';
import { GallerySettingsComponent } from '../common-settings/gallery-settings/gallery-settings.component';
import { GeneralSettingsComponent } from '../common-settings/general-settings/general-settings.component';
import { WebSettingsModule } from '@web/shared/components/web-settings/web-settings.module';

@Component({
    selector: 'web-preview-modal-settings',
    templateUrl: './preview-modal-settings.component.html',
    styleUrls: ['./preview-modal-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        WebSettingsModule,
        GeneralSettingsComponent,
        GallerySettingsComponent,
        TypographySettingsComponent,
        TranslateModule,
    ],
})
export class PreviewModalSettingsComponent extends WebBaseControlTypedSettingsComponent<PreviewModalSettingsFormGroup> {
    @Input() public widgetId: string;
    @Input() public cardKindViewType: CardKindViewType;

    public get generalSettingsFormGroup(): PreviewModalSettingsFormType['general'] {
        return this.itemForm.get('general') as PreviewModalSettingsFormType['general'];
    }

    public get gallerySettingsFormGroup(): PreviewModalSettingsFormType['gallery'] {
        return this.itemForm.get('gallery') as PreviewModalSettingsFormType['gallery'];
    }

    public get infoSettingsFormGroup(): PreviewModalSettingsFormType['info'] {
        return this.itemForm.get('info') as PreviewModalSettingsFormType['info'];
    }

    public get typographySettingsFormGroup(): PreviewModalSettingsFormType['typography'] {
        return this.itemForm.get('typography') as PreviewModalSettingsFormType['typography'];
    }
}
